import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import { SpinnerClass } from "core/classes/spinner.class";
import { Promise } from "es6-promise-polyfill";

$(document).ready(function() {
  if (!Abacus.PreventDefault.SPIN2VideoPartial) {
    $(".spinVideo").each(function() {
      Abacus.VideoPartial = new VideoPartial(this);
    });
  }
});

let VideoPartialOptions = {
  slide: ".swiper-slide"
};

class VideoPartial extends Class {
  constructor(element, options) {
    super();
    this.element = $(element);
    this.setOptions(VideoPartialOptions, options);
    this.slides = this.element.find(this.options.slide);
    this.container = this.element.find(".videoPreview-container");
    this.setEvents();
  }

  setEvents() {
    var self = this,
      slide = this.slides;
    slide.each(function() {
      $(this)
        .find("a")
        .on("click", function(evt) {
          evt.preventDefault();
          if ($(this).hasClass("nowPlaying")) return;
          let data = $(this).data("spinvideoPreview");
          self.makeRequest(data, this);
        });
    });
  }

  makeRequest(obj, element) {
    let self = this,
      req = new Promise((resolve, reject) => {
        $.ajax({
          url: obj.url,
          beforeSend: () => (self.spinner = new SpinnerClass(this.container)),
          success: data => resolve(data)
        });
      });

    req.then(data => {
      const container = this.container;
      container
        .find(".videoPreview-video")
        .replaceWith($(data).filter(".videoPreview-video"));
      container
        .find(".videoPreview-details")
        .replaceWith($(data).filter(".videoPreview-details"));
      this.spinner.hide();
      this.focusFunction(container);
      this.togglePlayingClass(element);
      $(window).trigger("abacus:loadcontent:complete", [this.element]);
      $(window).trigger("abacus:spinvideopreview:complete", [this.element]);
    });
  }

  focusFunction(container) {
    if (container.find(".videoPreview-video .videoblock iframe").length) {
      var frame = container.find(".videoPreview-video .videoblock iframe");
    } else {
      var frame = container.find(".videoPreview-video .audioblock iframe");
    }
    if (frame.length) {
      container.find(".videoPreview-details h2 a").focus();
    }
  }

  togglePlayingClass(element) {
    this.slides.find("a").removeClass("nowPlaying");
    $(element).addClass("nowPlaying");
  }
}

export { VideoPartial };



// WEBPACK FOOTER //
// ./Javascript/core/classes/spin2/spin.video.preview.class.js